import { gql } from "@apollo/client"

// export type SingleStringValue = {
//   value: string;
// }

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

// USER LOGIN
export const USER_LOGIN = gql`
  query Authenticate($username: String!, $password: String!) {
    authenticate(username: $username, password: $password) {
      code
      success
      message
    }
  }`;

export type LoginArgs = {
  username: string;
  password: string;
}

export interface LoginResponse {
  authenticate: Def_MutationResponse;
}

// CREATE USER
export const CREATE_USER = gql`
  mutation Create($username: String!, $password: String!, $firstname: String, $lastname: String, $email: String, $phone: String) {
    user {
      create(username: $username, password: $password, firstname: $firstname, lastname: $lastname, email: $email, phone: $phone) {
        code
        success
        message
      }
    }
  }
`;

export type CreateArgs = {
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}
export interface CreateUserResponse {
  user: {
    create: Def_MutationResponse;
  }
}

// USER INFO
export const USER_INFO = gql`
query UserInfo($jwt: String!) {
  user {
    info(jwt: $jwt) {
      address
      country
      email
      firstname
      lastname
      phone
      user_id
      username
    }
  }
}`;
export interface User_Data {
  user_id:number;
  username:string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  address: string;
  country: string;
}

export type UserInfoArgs = {
  jwt: string;
}

export interface UserInfoResponse {
  user: {
    info: User_Data;
  }
}

// UPDATE USER INFO
export const UPDATE_USER_INFO = gql`
  mutation UpdateInfo($jwt: String!, $firstname: String!, $lastname: String!, $phone: String!, $email: String!, $country: String!, $address: String!) {
    user {
      updateInfo(jwt: $jwt, firstname: $firstname, lastname: $lastname, phone: $phone, email: $email, address: $address, country: $country) {
        code
        success
        message
      }
    }
  }  
`;

export type UpdateUserInfoArgs = {
  jwt: string;
} & Partial<User_Data>

export interface UpdateUserInfoResponse {
  user: {
    updateInfo: Def_MutationResponse;
  }
}
// ALLUSER INFO

export type Company_Data = {
  company_id: number;
  name: string;
  domain: string;
  legacy: boolean;
};

export type UserGroups_Data = {
  user_group_id: number;
  name: string;
  description: string;
  fk_company: number;
};
export type AllUser_Data = {
  user_id: number;
  username: string;
  firstname: string | null;
  lastname: string | null;
  phone: string | null;
  email: string | null;
  country: string | null;
  address: string | null;
  user_companies: Company_Data[];
  user_groups: UserGroups_Data[];
};


export const ALLUSER_INFO = gql`
query AllUsers {
  user {
    allUsers {
      user_id
      username
      firstname
      lastname
      phone
      email
      country
      address
      user_companies {
        company_id
        name
        domain
        legacy
      }
      user_groups {
        user_group_id
        name
        description
        fk_company
      }
    }
  }
}`;

export interface AllUserInfoResponse {
  user: {
    allUsers: AllUser_Data[];
  };
}
// add domain (for users)
export const ADD_DOMAIN_USER = gql`
mutation AddDomainUser($username: String!, $domain: String!) {
  user {
    addDomainUser(username: $username, domain: $domain) {
      code
      message
      success
    }
  }
}
`
export interface AddDomainUserResponse {
  user: {
    addDomainUser: Def_MutationResponse
  }
}
//Add group to user
export const ADD_GROUP_TO_USER = gql`
mutation AddGroupUser($domain: String!, $username: String!, $usergroupid: Int!) {
  user {
    addGroupUser(domain: $domain, username: $username, usergroupid: $usergroupid) {
      code
      success
      message
    }
  }
}
`
export interface AddGroupUserResponse {
  user: {
    addGroupUser: Def_MutationResponse
  }
}
//query all domains
export const ALL_DOMAINS = gql`
query Companies {
  user {
    companies {
      company_id
      name
      domain
      legacy
    }
  }
}
`
export interface AllCompaniesResponse {
  user: {
    companies: Company_Data[];
  }
}
//query user groups in selected domain
export const USER_GROUPS = gql`
query Groups($domain: String!) {
  company {
    groups(domain: $domain) {
      user_group_id
      name
      description
      fk_company
    }
  }
}
`
export interface UserGroupsResponse {
  company: {
    groups: UserGroups_Data[];
  }
}